module.exports = __webpack_public_path__ + "media/stylesheets/images/temp_wolf_planent_kit/card_kit_3-5d6ab15163c1653ebb06c15afccf63d8.png";